export const WHITELISTED_URLS: readonly string[] = [
  '/dashboard',
  '/search/loads',
  '/search/availabilities',
  '/cargo-categories',
  '/transport-routes',
] as const;
